import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActiveStore } from 'ggApp/modules/store';
import { User } from 'ggApp/modules/auth/selectors';
/**
 * This is what going to be a connector between Micro frontend app and End Module
 * * */

export type PaymentsModuleContextType = {
    activeStore: Partial<ActiveStore>;
    router: {
        goBack: () => void;
        push: (push: string) => void;
    };
    user: Partial<User>;
    dispatch: any;
    useTranslation: typeof useTranslation;
};

const PaymentsModuleContext = React.createContext<PaymentsModuleContextType>({
    activeStore: {
        code: 'en',
    },
    router: {
        goBack: () => {},
        push: (path: string) => {},
    },
    user: {},
    dispatch: () => {},
    useTranslation,
});

export const usePaymentsModule = () => {
    const { activeStore, router, user } = React.useContext(PaymentsModuleContext);

    return { activeStore, router, user };
};

export default PaymentsModuleContext;
